var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_lexique_remoteEntry_mjs_c0dfd33c__;